import { render } from "./business-card-stats-modal.vue?vue&type=template&id=2a42e364&scoped=true"
import script from "./business-card-stats-modal.vue?vue&type=script&lang=js"
export * from "./business-card-stats-modal.vue?vue&type=script&lang=js"

import "./business-card-stats-modal.vue?vue&type=style&index=0&id=2a42e364&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a42e364"]])

export default __exports__